module.exports = __webpack_public_path__ + "static/media/crimp-icon@0,5x.35659c56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/crimp-icon@0,5x.png
// module id = 1328
// module chunks = 0